import { render, staticRenderFns } from "./TitleBarV1.vue?vue&type=template&id=8eff39a0&scoped=true&"
import script from "./TitleBarV1.vue?vue&type=script&lang=js&"
export * from "./TitleBarV1.vue?vue&type=script&lang=js&"
import style0 from "./TitleBarV1.vue?vue&type=style&index=0&id=8eff39a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eff39a0",
  null
  
)

export default component.exports